@if (slidersData$ | async; as sliderData) {
  @if (sliderData?.finalContainers?.length > 0 || sliderData?.finalContainerItems?.length > 0) {
    @if (showScrollContainer) {
      @switch (compData?.container?.type) {
        @case ('OFFER_SLIDER') {
          <ng-container *ngTemplateOutlet="offerSliderTemplate; context: { sliderData: sliderData }"></ng-container>
        }
        @case ('PROMO_SLIDER') {
          <ng-container *ngTemplateOutlet="promoSliderTemplate; context: { sliderData: sliderData }"></ng-container>
        }
        @case ('PROPERTY_GRID_SLIDER') {
          <ng-container
            *ngTemplateOutlet="propertyGridSliderTemplate; context: { sliderData: sliderData }"></ng-container>
        }
        @default {
          <ng-container *ngTemplateOutlet="defaultTemplate; context: { sliderData: sliderData }"></ng-container>
        }
      }
    }
  }
} @else {
  @if (this.compData?.container?.apiURL) {
    <!-- TODO Show skeleton -->
      <!--<div class="titleBox loading"></div>
      <div class="descBox loading"></div>-->
    <div class="box loading"></div>
  }
}

<ng-template #defaultTemplate let-sliderData="sliderData">
  <app-b2b-drag-scroll
    [config]="config"
    [container]="compData?.container">
    @for (slide of sliderData?.finalContainers; track slide; let index = $index) {
      <app-b2b-drag-scroll-item [config]="config" [ngClass]="{ 'divider': config?.divider }">
        <app-b2b-slider-item
          [compData]="{
            container: slide
          }">
        </app-b2b-slider-item>
      </app-b2b-drag-scroll-item>
    }
    @for (slide of sliderData?.finalContainerItems; track slide; let index = $index) {
      <app-b2b-drag-scroll-item [config]="config" [ngClass]="{ 'divider': config?.divider }">
        <app-b2b-slider-item
          [compData]="{
            containerItem: slide
          }"
        >
        </app-b2b-slider-item>
      </app-b2b-drag-scroll-item>
    }
  </app-b2b-drag-scroll>
</ng-template>

<ng-template #offerSliderTemplate let-sliderData="sliderData">
  <div class="">
    <app-b2b-drag-scroll
      [config]="config"
      [container]="compData?.container"
      [limitDescToMaxLength]="true"
      [showHeader]="true"
    >
      <div header>
        <div class="exp-tab flex-container ion-align-items-start">
          @for (container of sliderData?.finalContainers; track container; let index = $index; ) {
            @if ((isMobile && index < 2) || !isMobile) {
              <div class="tab-name"
                   [ngClass]="{ 'active': container?.type === sliderData?.selectedContainer?.type }"
                   (click)="sliderData.selectedContainer = container">
                {{ container?.title | titlecase }}
              </div>
            }
          }
          <div class="tab-name more-opt">
            <app-b2b-popover-v1
              [allowContentDrop]="true"
              [left]="'auto'"
              [padding]="'0px'"
              [right]="'-10px'"
              [width]="isMobile ? '170px': '220px'">
              <div class="info-icon" header>
                <span class=""> More
                <svg class="size-3" fill="none" stroke="currentColor" stroke-width="2.5"
                     viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                  <path d="m19.5 8.25-7.5 7.5-7.5-7.5" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
                </span>
              </div>
              <div body class="bodySec">
                @for (container of sliderData?.finalContainers; track container) {
                  <div class="all-tab-name"
                       [ngClass]="{ 'active': container?.type === sliderData?.selectedContainer?.type }"
                       (click)="sliderData.selectedContainer = container">
                    {{ container?.title | titlecase }}
                  </div>
                }
              </div>
            </app-b2b-popover-v1>
          </div>
        </div>
      </div>

      @if (compData?.container?.rows > 1) {
        @for (slideArray of sliderData?.selectedContainer?.containers | b2bSlice: compData?.container?.rows; track slideArray; let index = $index) {
          <app-b2b-drag-scroll-item [config]="config" [ngClass]="{ 'divider': config?.divider }">
            <div class="multirow-items">
              @for (slide of slideArray; track slide; let index = $index) {
                @if (config?.cardType === 'CARD_V') {
                  <ng-container
                    *ngTemplateOutlet="cardVTemplate; context: { slide: slide }"
                  ></ng-container>
                } @else {
                  <ng-container
                    *ngTemplateOutlet="cardHTemplate; context: { slide: slide }"
                  ></ng-container>
                }
              }
            </div>

          </app-b2b-drag-scroll-item>
        }
      } @else {
        @for (slide of sliderData?.selectedContainer?.containers; track slide; let index = $index) {
          <app-b2b-drag-scroll-item [config]="config" [ngClass]="{ 'divider': config?.divider }">
            @if (config?.cardType === 'CARD_V') {
              <ng-container
                *ngTemplateOutlet="cardVTemplate; context: { slide: slide }"
              ></ng-container>
            } @else {
              <ng-container
                *ngTemplateOutlet="cardHTemplate; context: { slide: slide }"
              ></ng-container>
            }
          </app-b2b-drag-scroll-item>
        }
      }
    </app-b2b-drag-scroll>
  </div>
</ng-template>

<ng-template #promoSliderTemplate let-sliderData="sliderData">
  <div>
    <app-b2b-drag-scroll
      [config]="config"
      [container]="compData?.container"
    >
      @if (compData?.container?.rows > 1) {
        @for (slideArray of (sliderData?.finalContainers | b2bSlice: compData?.container?.rows); track slideArray; ) {
          <app-b2b-drag-scroll-item [config]="config">
            <div>
              @for (slide of slideArray; track slide; let index = $index) {
                @if (config?.cardType === 'CARD_H') {
                  <ng-container
                    *ngTemplateOutlet="cardHTemplate; context: { slide: slide }"
                  ></ng-container>
                } @else {
                  <ng-container
                    *ngTemplateOutlet="cardVTemplate; context: { slide: slide }"
                  ></ng-container>
                }
              }
            </div>
          </app-b2b-drag-scroll-item>
        }
      } @else {
        @for (slide of sliderData?.finalContainers; track slide; let index = $index) {
          <app-b2b-drag-scroll-item [config]="config" [ngClass]="{ 'divider': config?.divider }">
            <div>
              @if (config?.cardType === 'CARD_H') {
                <ng-container
                  *ngTemplateOutlet="cardHTemplate; context: { slide: slide }"
                ></ng-container>
              } @else {
                <ng-container
                  *ngTemplateOutlet="cardVTemplate; context: { slide: slide }"
                ></ng-container>
              }
            </div>
          </app-b2b-drag-scroll-item>
        }
      }
    </app-b2b-drag-scroll>
  </div>
</ng-template>

<ng-template #cardVTemplate let-slide="slide">
  <a (click)="onCardClick(slide)" class="promoSliderCard" tapEffect
     href="{{ (slide?.externalUrl ? slide?.externalUrl : hostWebsite + slide?.navigationURL) }}"
     onclick="return false;"
  >
    @if (slide?.image?.path) {
      <div class="imgWrap" [ngStyle]="{ 'max-height': slide?.image?.height,  'max-width': slide?.image?.width }">
        <img
          alt="image"
          ngSrc="{{ slide?.image?.path }}?height={{ slide?.image?.minHeight }}&format=webp&quality=100"
          width="100"
          height="100"
          loading="lazy"
        >
      </div>
    }
    <div class="promoCardBody">
      <div class="promoCardPad">
        @if (slide?.title) {
          <app-text-clamp-shell
            class="title" [config]="{ data: (slide?.title), row: 2 }">
          </app-text-clamp-shell>
        }
        @if (slide?.description) {
          <div class="descPad">
            <app-text-clamp-shell
              class="desc"
              [loadNgContent]="false"
              [config]="{ data: slide?.description, row: 2 }">
            </app-text-clamp-shell>
          </div>
        }
      </div>
    </div>
  </a>
</ng-template>

<ng-template #cardHTemplate let-slide="slide">
  <div class="offerSliderCard">
    <div class="coupon-card">
      <div class="couponImg">
        <div [ngStyle]="{ 'max-height': slide?.image?.height,  'max-width': slide?.image?.width }" class="imgSec">
          <img alt="image" height="100" loading="lazy"
               ngSrc="{{ slide?.image?.path }}?height={{ slide?.image?.minHeight }}&format=webp&quality=100"
               width="100">

        </div>
      </div>
      <div class="couponContent">
        <div>

          <!-- @if (slide?.category) {
             &lt;!&ndash; TODO need to enable in future &ndash;&gt;
             <div class="badge">{{ slide?.category }}</div>
           }-->
          @if (slide?.title) {
            <app-text-clamp-shell
              class="title"
              [config]="{ data: (slide?.title), row: 2 }">
            </app-text-clamp-shell>
          }
          @if (slide?.description) {
            <app-text-clamp-shell
              class="desc"
              [loadNgContent]="false"
              [config]="{ data: (slide?.description), row: 2 }">
            </app-text-clamp-shell>
          }
          @if (slide?.subTitle && slide?.type) {
            <div class="flags">
              <div class="flag-title"
                   [ngClass]="{'cmg-soon': slide?.type === 'UPCOMING', 'live': slide?.type === 'LIVE', 'expired': slide?.type === 'EXPIRED'}"
              >
                {{ slide?.subTitle }}
              </div>
            </div>
          }
          <!--@if (slide?.subTitle) {
            &lt;!&ndash; TODO need to enable in future &ndash;&gt;
            <div><span>{{ slide?.subTitle }}</span></div>
          }-->
        </div>
        <div class="footer-btn">
          @if (slide?.couponCode) {
            <div class="code">Code: {{ slide?.couponCode }}</div>
          }
          @if (slide?.briefDesc) {
            <div class="code">{{ slide?.briefDesc }}</div>
          }
          <a (click)="onCardClick(slide)" class="detail-btn" tapEffect
             href="{{ (slide?.externalUrl ? slide?.externalUrl : hostWebsite + slide?.navigationURL) }}"
             onclick="return false;"
          >View Details</a>
        </div>
      </div>
    </div>
  </div>
</ng-template>


<ng-template #propertyGridSliderTemplate let-sliderData="sliderData">
  @if (!isMobile) {
    @if (compData?.container?.title) {
      <div class="leftHeading">
        <h4 class="sliderHeading font-bold">
          {{ compData?.container?.title | titlecase }}
        </h4>
      </div>
    }
    <div class="grid-container">
      @for (slide of sliderData?.finalContainers; track slide; let index = $index) {
        <div [ngStyle]="{ minHeight: slide?.sliderMinHeight + 'px' }" class="img-slider grid-item">
          @if (((slide?.component | b2bDynamicLoaderPipe: slide?.key) | async); as component; ) {
            <ng-container *ngComponentOutlet="component; inputs: {
              compData: {
                  containerItem: slide,
                  container: slide,
              }
            }"/>
          } @else {
            <!--placeholder-->
            <div class="sk-bx loading"></div>
          }
        </div>
      }
    </div>
  } @else {

    @let rows = sliderData?.originalContainer?.rows > 0 ? sliderData?.originalContainer?.rows : 1;
    @let background = sliderData?.originalContainer?.background ? sliderData?.originalContainer?.background : '#ffffff';

    <div class="mob-grid"
         [ngStyle]="{'background-color': background}">
      @if (rows > 1) {
        <app-b2b-drag-scroll
          [config]="config"
          [container]="compData?.container"
          [limitDescToMaxLength]="true"
          [showHeader]="true"
        >
          @for (slideArray of sliderData?.finalContainers | b2bSlice: rows; track slideArray; let index = $index) {
            <app-b2b-drag-scroll-item [config]="config" [ngClass]="{ 'divider': config?.divider }">
              <div class="multirow-items">
                @for (slide of slideArray; track slide; let index = $index) {
                  <div [ngStyle]="{ minHeight: slide?.sliderMinHeight + 'px' }"
                       class="c-margin-bottom img-slider grid-item">
                    @if (((slide?.component | b2bDynamicLoaderPipe: slide?.key) | async); as component; ) {
                      <ng-container *ngComponentOutlet="component; inputs: {
                      compData: {
                          containerItem: slide,
                          container: slide,
                      }
                    }"/>
                    } @else {
                      <!--placeholder-->
                      <div class="sk-bx loading"></div>
                    }
                  </div>
                }
              </div>

            </app-b2b-drag-scroll-item>
          }
        </app-b2b-drag-scroll>
      } @else {
        <app-b2b-drag-scroll
          [config]="config"
          [container]="compData?.container"
          [limitDescToMaxLength]="true"
          [showHeader]="true"
        >
          @for (slide of sliderData?.finalContainers; track slide?.uid; let index = $index) {

            <app-b2b-drag-scroll-item [config]="config" [ngClass]="{ 'divider': config?.divider }">
              <div class="multirow-items">
                <div [ngStyle]="{ minHeight: slide?.sliderMinHeight + 'px' }"
                     class="c-margin-bottom img-slider grid-item">
                  @if (((slide?.component | b2bDynamicLoaderPipe: slide?.key) | async); as component; ) {
                    <ng-container *ngComponentOutlet="component; inputs: {
                      compData: {
                          containerItem: slide,
                          container: slide,
                      }
                    }"/>
                  } @else {
                    <!--placeholder-->
                    <div class="sk-bx loading"></div>
                  }
                </div>
              </div>
            </app-b2b-drag-scroll-item>

          }
        </app-b2b-drag-scroll>
      }

    </div>
  }

</ng-template>
